var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeechBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.34,72.56c-14.87-13.38-33.09-18.81-52.39-21a116.32,116.32,0,0,0-36,1.38c-15.78,3.14-30.56,8.5-42.81,19.45-14.61,13.1-19.91,32.76-4.76,50.72,6.73,8,15.27,13.41,24.73,17.47A3.17,3.17,0,0,1,63.32,144c-.09,10,0,20.08,0,30.12v3.14c1.11-1.06,1.75-1.65,2.38-2.27,8-8,16-15.87,23.84-23.94A6.48,6.48,0,0,1,95.3,149c15.72,1.34,31.21.22,46.4-4.48,12.73-3.95,24.34-9.78,33.62-19.53,6.23-6.56,10.33-14.29,10.6-23.53.36-11.86-5.06-21.19-13.58-28.88M73.52,110.62a10.24,10.24,0,1,1,10.23-10.24,10.24,10.24,0,0,1-10.23,10.24m34.44,0a10.24,10.24,0,1,1,10.24-10.24A10.24,10.24,0,0,1,108,110.62m33.56,0a10.24,10.24,0,1,1,10.25-10.24,10.23,10.23,0,0,1-10.25,10.24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble);
export default __webpack_public_path__ + "static/media/SPEECH_BUBBLE.e7c14a55b3690562bb11e574dd28f9ba.svg";
export { ForwardRef as ReactComponent };